<template>
  <!-- 通用图标选择：输入框 + Grid 图标弹框，支持 v-model -->
  <div class="icon-select">
    <el-input readonly :model-value="modelValue" :placeholder="placeholder" :disabled="disabled" @click="open">
      <template #suffix>
        <yq-icon v-if="modelValue" :name="modelValue"/>
        <yq-icon v-else name="element-ui_arrow-down"/>
      </template>
    </el-input>
    <el-dialog v-model="showDialog" title="请选择图标" dialog-width="2" append-to-body>
      <el-input v-model="filterKey" placeholder="请输入图标名称过滤" @keyup="filterIcons" clearable/>
      <dialog-table>
        <div class="icon-grid">
          <div v-for="item in filteredIcons" :key="item" class="dialog-icon"
               :class="modelValue === item ? 'icon-on' : ''" @click="choose(item)">
            <yq-icon class="dialog-icon-item" :name="item"/>
            <div class="dialog-icon-text" :title="item">{{ item }}</div>
          </div>
        </div>
      </dialog-table>
      <template #footer>
        <page-button @click="showDialog = false">取消</page-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import YqIcon from "@/components/YqIcon.vue";
import DialogTable from "@/components/h5/layout/DialogTable.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import config from "@/config/config";

export default {
  name: "IconSelect",
  emits: ["update:modelValue", "change"],
  components: {
    YqIcon, DialogTable, PageButton
  },
  props: {
    modelValue: {default: ""},
    placeholder: {default: "请选择图标"},
    disabled: {default: false},
  },
  data() {
    return {
      iconList: config.iconList,
      filteredIcons: [],
      filterKey: "",
      showDialog: false,
    };
  },
  methods: {
    open() {
      if (this.disabled) {
        return;
      }
      this.filterKey = "";
      this.filteredIcons = this.iconList;
      this.showDialog = true;
    },
    filterIcons() {
      const key = this.filterKey || "";
      this.filteredIcons = this.iconList.filter(item => item.indexOf(key) > -1);
    },
    choose(icon) {
      this.$emit("update:modelValue", icon);
      this.$emit("change", icon);
      this.showDialog = false;
    },
  }
};
</script>

<style lang="scss" scoped>
// 弹框是 append-to-body 的，样式放顶层作用域，避免依赖父组件 DOM
.icon-grid {
  display: grid;
  grid-template-columns: repeat(8, minmax(0, 1fr));
  gap: 10px;
}

.dialog-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px 4px;
  border: 1px solid var(--el-border-color);
  border-radius: 6px;
  cursor: pointer;

  .dialog-icon-item {
    font-size: 28px;
  }

  .dialog-icon-text {
    width: 100%;
    margin-top: 6px;
    font-size: 12px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &:hover {
    border-color: var(--el-color-primary);
  }

  &.icon-on {
    color: #FFF;
    background-color: var(--el-color-primary);
    border-color: var(--el-color-primary);
  }
}
</style>
